module.exports = __webpack_public_path__ + "static/media/Three.3768b103.png";